// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@vanmeter/App/SharedStyles/CartLineSharedStyles";
import { purchasedProductCardStyles } from "@vanmeter/Overrides/Components/PurchasedProductCard";
import { xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

purchasedProductCardStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};

purchasedProductCardStyles.partNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

purchasedProductCardStyles.priceStyles = {
    ...cartLineSharedStyles.productPrice,
};

purchasedProductCardStyles.descriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

purchasedProductCardStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 96px minmax(0, 1fr) minmax(0, 184px) minmax(0, 137px) minmax(0, 184px);

            ${xScreen("lte", "lg")} {
                grid-template-columns: 96px minmax(0, 1fr) minmax(0, 154px) minmax(0, 114px) minmax(0, 154px);
            }
        `,
    },
    total: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / -1;
                grid-row: 5 / 6;
            }
        `,
    },
    remove: {
        css: css`
            display: none;
        `,
    },
};
